import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Badge, Button, Card, CardBody, CardHeader, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import { AxiosResponse } from 'axios';
import moment from 'moment';
import { CSVLink } from "react-csv";

import Header from '../../../components/Headers/Header';
import CustomTable from '../../../components/Tables/CustomTable';

import { PATHS } from '../../../routes';
import { TypeTicketReportData } from '../../../types';
import { getStudentsList } from '../../../Services/Ticket/ticketService';
import useTeacherProfile from '../../../Hooks/useTeacherProfile';
import { TypeTeacherSchool } from '../../../Reducers/types';
import { toast } from 'react-toastify';

export default function Grievance() {

    const history = useHistory();
    const teacherProfile: TypeTeacherSchool = useTeacherProfile(); // stores teacher profile information

    const downloadReport = useRef<any>(null);

    // --- dropdown for ticket status ---
    const [statusDropdown, setStatusDropdown] = useState(false);
    const statusDropdownToggle = () => setStatusDropdown(prevState => !prevState);
    // --- dropdown for ticket type ---
    const [typeDropdown, setTypeDropdown] = useState(false);
    const typeDropdownToggle = () => setTypeDropdown(prevState => !prevState);

    // filter states
    const [ticketState, setTicketState] = useState<'pending' | 'closed'>('pending'); // sets the status of ticket, pending or closed
    const [ticketType, setTicketType] = useState<'query' | 'greivance' | 'support'>('query'); // sets type of ticket

    const [subjectList, setSubjectList] = useState<string>(""); // stores subject list
    const [studentList, setStudentList] = useState<string>(""); // stores student list

    // report
    const [reportData, setReportData] = useState<TypeTicketReportData>(); // holds report data fot CSV download
    const [isLoading, setIsLoading] = useState<boolean>(false); // for file/report download

    useEffect(() => {
        filterGrades()
        filterSubjects();
    }, [])

    const filterGrades = () => {
        // filters grade-section list based on current session
        let gradeList = teacherProfile?.gradelist?.map(({ grade_section_id, subject }) => {
            if (moment(new Date()).format('YYYY-MM-DD') >= moment(grade_section_id?.session?.session_start).format('YYYY-MM-DD')
                &&
                moment(new Date()).format('YYYY-MM-DD') <= moment(grade_section_id?.session?.session_end).format('YYYY-MM-DD')) {
                return { grade_section_id };
            }
        });
        let grades = gradeList?.map((each) => each?.grade_section_id?.id);
        getStudentList(grades);
    };

    // get all distinct subject ids
    const filterSubjects = () => {
        // gets subject list
        let subjectList = teacherProfile?.gradelist?.map(({ subject }) => {
            return { subject };
        });
        // filters only subject array
        let subjects = subjectList?.map(({ subject }) => {
            return subject?.map((each) => each?.subject_id?.id)
        });
        // stores distinct subject ids
        let unique = Array.from(new Set(subjects.flat()));
        setSubjectList(unique?.join(","));
    };

    // get studentlist for all grades that are assigned to the teacher
    const getStudentList = (grades: number[]) => {
        getStudentsList(grades?.join(",")).then(
            (response: AxiosResponse) => {
                // console.log("Response for student list: ", response?.data?.data);
                let studentList = response?.data?.data?.map((each) => each?.student_profile_id?.user?.id);
                console.log("Student list: ", studentList.join(","));
                setStudentList(studentList?.join(","));
            }, (error) => {
                console.log("Error caught: ", error?.response);
                toast.error("Sorry...Could not show grievances!");
            }
        );
    };

    // generates report for tickets(Grievance, Query, Support)
    // const generateReport = () => {
    //     setIsLoading(true);

    //     generateTicketReport().then(
    //         (response: AxiosResponse) => {
    //             // console.log("Response for reports data: ", response?.data?.data);
    //             let grievance = [];
    //             let query = [];
    //             let support = [];

    //             response?.data?.data?.forEach((each) => {
    //                 if (each?.query_type === 'greivance') {
    //                     grievance.push(each);
    //                 } else if (each?.query_type === 'query') {
    //                     query.push(each);
    //                 } else {
    //                     support.push(each);
    //                 }
    //             });

    //             // form data to download CSV
    //             let listData = [{
    //                 no_of_grievnce_reported: grievance?.length || 0,
    //                 no_of_grievnce_resolved: grievance?.filter((each) => (each?.status === 'closed'))?.length || 0,
    //                 grievance_resolved_in_time: grievance?.filter((each) => (+each?.resolved_with_in <= 7 && +each?.resolved_with_in !== -1))?.length || 0,
    //                 grievance_resolved_with_delay: grievance?.filter((each) => (+each?.resolved_with_in > 7))?.length || 0,
    //                 average_time_for_resolved_grievance: Math.round(grievance?.reduce((accu, each) => (accu += +each?.resolved_with_in), 0) / grievance?.length) + ' Days' || 'Not Available',
    //                 no_of_grievnce_pending: grievance?.filter((each) => (each?.status === 'pending'))?.length || 0,
    //                 "*": "",
    //                 no_of_query_reported: query?.length || 0,
    //                 no_of_query_resolved: query?.filter((each) => (each?.status === 'closed'))?.length || 0,
    //                 query_resolved_in_time: query?.filter((each) => (+each?.resolved_with_in <= 2 && +each?.resolved_with_in !== -1))?.length || 0,
    //                 query_resolved_with_delay: query?.filter((each) => (+each?.resolved_with_in > 2))?.length || 0,
    //                 average_time_for_resolved_query: Math.round(query?.reduce((accu, each) => (accu += +each?.resolved_with_in), 0) / query?.length) + ' Days' || 'Not Available',
    //                 no_of_query_pending: query?.filter((each) => (each?.status === 'pending'))?.length || 0,
    //                 "": "",
    //                 no_of_support_reported: support?.length || 0,
    //                 no_of_support_resolved: support?.filter((each) => (each?.status === 'closed'))?.length || 0,
    //                 no_of_support_pending: support?.filter((each) => (each?.status === 'pending'))?.length || 0,
    //             }];
    //             let header = [
    //                 { label: "Number of Grievance Reported", key: "no_of_grievnce_reported" },
    //                 { label: "Number of Grievance Resolved", key: "no_of_grievnce_resolved" },
    //                 { label: "Grievance Resolved In Time", key: "grievance_resolved_in_time" },
    //                 { label: "Grievance Resolved With Delay", key: "grievance_resolved_with_delay" },
    //                 { label: "Average Time To Resolve Grievance", key: "average_time_for_resolved_grievance" },
    //                 { label: "Number of Grievance Pending", key: "no_of_grievnce_pending" },
    //                 { label: '**********', key: '**********' },
    //                 { label: "Number of Query Reported", key: "no_of_query_reported" },
    //                 { label: "Number of Query Resolved", key: "no_of_query_resolved" },
    //                 { label: "Query Resolved in Time", key: "query_resolved_in_time" },
    //                 { label: "Query Resolved With Delay", key: "query_resolved_with_delay" },
    //                 { label: "Average Time To Resolve Query", key: "average_time_for_resolved_query" },
    //                 { label: "Number of Query Pending", key: "no_of_query_pending" },
    //                 { label: '**********', key: '**********' },
    //                 { label: 'Number of Support Reported', key: "no_of_support_reported" },
    //                 { label: "Number of Support Resolved", key: "no_of_support_resolved" },
    //                 { label: "Number of Support Pending", key: "no_of_support_pending" }
    //             ];
    //             console.log("Data: ", listData, " Header: ", header);
    //             setReportData((oldData) => ({ ...oldData, data: listData, headers: header }));

    //         }, (error) => {
    //             console.log("Error caught: ", error?.response);
    //         }
    //     ).finally(() => {
    //         setIsLoading(false);
    //         downloadReport.current?.link?.click()
    //     });
    // };

    return (
        <React.Fragment>
            <Header />

            {/* Page content */}

            <Container className="mt--7" fluid>
                <Card className="shadow"> {/* bg-gradient-default */}
                    <CardHeader className="bg-transparent">
                        <Row className="align-items-center">
                            <div className="col">
                                <h3 className="mb-0 text-muted"><i className="fas fa-ticket-alt mr-1"></i>Available Tickets</h3>
                            </div>
                            {/* <div className="col d-flex justify-content-end">
                                <Button size="sm" color={!ticketState ? 'primary' : ''} onClick={() => setTicketState(0)}>Pending</Button>
                                <Button size="sm" color={ticketState ? 'primary' : ''} onClick={() => setTicketState(1)}>Closed</Button>
                            </div> */}
                        </Row>
                        <Row>
                            <div className="w-100 p-2 mt-3 rounded filter-div-bg">
                                {/* STATUS DROPDOWN */}
                                <Dropdown size="sm" isOpen={statusDropdown} direction="down" toggle={statusDropdownToggle}>
                                    <DropdownToggle caret>
                                        {<span><span className="text-primary text-capitalize">{ticketState}</span></span>}
                                    </DropdownToggle>
                                    <DropdownMenu style={{ maxHeight: 300, overflow: 'auto' }}>
                                        <DropdownItem onClick={() => { setTicketState('pending') }}>
                                            <span className="d-flex justify-content-between align-items-center">
                                                Pending {ticketState === 'pending' && <i className="fas fa-check-circle text-primary"></i>}
                                            </span>
                                        </DropdownItem>
                                        <DropdownItem onClick={() => { setTicketState('closed') }}>
                                            <span className="d-flex justify-content-between align-items-center">
                                                Closed {ticketState === 'closed' && <i className="fas fa-check-circle text-primary"></i>}
                                            </span>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>

                                {/* TYPE DROPDOWN */}
                                <Dropdown size="sm" isOpen={typeDropdown} direction="down" toggle={typeDropdownToggle}>
                                    <DropdownToggle caret>
                                        {<span><span className="text-primary text-capitalize">{ticketType}</span></span>}
                                    </DropdownToggle>
                                    <DropdownMenu style={{ maxHeight: 300, overflow: 'auto' }}>
                                        <DropdownItem onClick={() => { setTicketType('query') }}>
                                            <span className="d-flex justify-content-between align-items-center">
                                                Query {ticketType === 'query' && <i className="fas fa-check-circle text-primary"></i>}
                                            </span>
                                        </DropdownItem>
                                        <DropdownItem onClick={() => { setTicketType('greivance') }}>
                                            <span className="d-flex justify-content-between align-items-center">
                                                Grievance {ticketType === 'greivance' && <i className="fas fa-check-circle text-primary"></i>}
                                            </span>
                                        </DropdownItem>
                                        <DropdownItem onClick={() => { setTicketType('support') }}>
                                            <span className="d-flex justify-content-between align-items-center">
                                                Support {ticketType === 'support' && <i className="fas fa-check-circle text-primary"></i>}
                                            </span>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>

                                {/* REPORT */}
                                {/* {!isLoading ? (<Button
                                    color="primary"
                                    size="sm"
                                    className="float-right"
                                    onClick={generateReport}>
                                    Get Report
                                    <i className="fas fa-file-alt ml-1"></i>
                                </Button>) : (<Button
                                    className="mx-3 float-right"
                                    size="sm"
                                    color="primary"
                                    type="button">
                                    <div
                                        className="spinner-border rounded-circle spinner-border-sm"
                                        role="status">
                                        <p className="sr-only">Loading...</p>
                                    </div>
                                </Button>)}
                                {reportData ? <CSVLink
                                    data={reportData?.data}
                                    headers={reportData?.headers}
                                    filename={`Ticket_Report_${moment().format('DD-MM-YYYY')}.csv`}
                                    target="_blank"
                                    className="d-none"
                                    ref={downloadReport}
                                >
                                    Download List <i className="fas fa-file-download ml-1"></i>
                                </CSVLink> : <></>} */}
                            </div>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <div>
                            {(studentList !== "" && subjectList !== "") && <CustomTable
                                url={`items/ticket?filter[status]=${ticketState}&filter[query_type]=${ticketType}&filter[subject][in]=${subjectList}&filter[user][in]=${studentList}&fields=id,query,status,subject.*,created_on,query_type,user.*&meta=filter_count`}
                                column={[]}
                                tableTitle={''}
                                searchBox={false}
                                itemsLimit={5}
                                customFunction={() => { }}
                                customColumns={[
                                    {
                                        heading: "#",
                                        renderer: (item: any) => (
                                            <span
                                                className="text-primary font-weight-bold pointer font-weight-bolde"
                                                onClick={() => { history.push(PATHS.ticketDetails + '/' + item?.id) }}>
                                                {item?.id}
                                            </span>
                                        ),
                                    },
                                    {
                                        heading: "Student",
                                        renderer: (item: any) => (
                                            <React.Fragment>{item?.user?.first_name + ' ' + item?.user?.last_name}</React.Fragment>
                                        ),
                                    },
                                    {
                                        heading: "Subject",
                                        renderer: (item: any) => (
                                            <React.Fragment>{item?.subject?.name}</React.Fragment>
                                        ),
                                    },
                                    {
                                        heading: "Issued On",
                                        renderer: (item: any) => (
                                            <React.Fragment>{moment(item?.created_on).format("MMM Do YYYY")}</React.Fragment>
                                        ),
                                    },
                                    {
                                        heading: 'Status',
                                        renderer: (item: any) => {
                                            return item?.status === 'closed' ? (
                                                <Badge color={'success'}>Closed</Badge>
                                            ) : item?.query_type === 'query' ? moment().diff(moment(item?.created_on), 'days') <= 2 ? (
                                                <Badge color={'warning'}>{item?.status}</Badge>
                                            ) : (
                                                <Badge color={'danger'}>Overdue</Badge>
                                            ) : item?.query_type === 'greivance' ? moment().diff(moment(item?.created_on), 'days') <= 7 ? (
                                                <Badge color={'warning'}>{item?.status}</Badge>
                                            ) : (
                                                <Badge color={'danger'}>Overdue</Badge>
                                            ) : <Badge color={'warning'}>{item?.status}</Badge>
                                        }
                                    }
                                ]} />}
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </React.Fragment>
    )
}
